<div mat-dialog-title>
  <div class="title-icon">
    <i class="fa fa-globe"></i>
  </div>
  <div class="title-text">{{ 'language_setting.title' | transloco }}</div>
</div>
<mat-dialog-content class="mat-typography dialog-content">
  @if (translationsDisabled()) {
    <div class="warning-message">
      <i class="fa fa-exclamation-triangle"></i>
      <span>{{ 'qr_translations.disabled_banner_message' | transloco }}</span>
    </div>
  }
  <form class="form">
    @if (!translationsDisabled() && (isMicrophoneKit$ | async)) {
      <h3>{{ 'language_setting.set_language_for' | transloco }}</h3>
      <div class="select-mode">
        <mat-button-toggle-group
          hideSingleSelectionIndicator
          [(value)]="updateMode"
          class="button-toggle-group">
          <mat-button-toggle value="all" class="mat-button-toggle">
            {{ 'language_setting.all' | transloco }}
          </mat-button-toggle>
          @if ((this.kit | async).license.feature_flag_translation) {
            <mat-button-toggle value="each" class="mat-button-toggle">
              {{ 'language_setting.each' | transloco }}
            </mat-button-toggle>
          }
        </mat-button-toggle-group>
      </div>
    }

    <div class="mic-settings" [class.mic-settings--with-icon]="isMicrophoneKit$ | async">
      <div class="mic-settings__labels">
        @if (isMicrophoneKit$ | async) {
          <div></div>
        }
        <div>{{ 'language_setting.spoken' | transloco }}</div>
        <div></div>
        <div>{{ 'language_setting.translate' | transloco }}</div>
      </div>

      <div class="mic-settings__container">
        @switch (updateMode) {
          @case ('all') {
            <div class="mic-settings__mic">
              @if (isMicrophoneKit$ | async) {
                <div class="icon">
                  <img src="assets/svg/kit-v2.svg" alt="" />
                </div>
              }
              <div class="language-in">
                <mat-form-field appearance="outline">
                  <mat-select
                    panelWidth="null"
                    #languageInSelector
                    hideSingleSelectionIndicator
                    [disabled]="
                      !(this.kit | async)?.license.feature_flag_translation ||
                      this.isQRAuthMode
                    "
                    (valueChange)="languageInChanged(-1, $event)"
                    [value]="
                      this.languageService.getLangFromCode(
                        (this.kit | async).microphones[0]?.language_in ||
                          (this.localLanguageIn$ | async) ||
                          (currentLanguage$ | async)?.transcriptionLanguage
                            .languageCode
                      )
                    ">
                    <mat-select-trigger>
                      <span
                        class="flag-icon mr-1"
                        [ngClass]="languageInSelector.value?.iconClass"></span>
                      {{
                        languageInSelector.value?.languageCode
                          .substring(0, 2)
                          .toUpperCase()
                      }}
                    </mat-select-trigger>
                    <mat-optgroup label="Verified">
                      @for (lang of languages; track lang) {
                        @if (lang.isVerified) {
                          <mat-option [value]="lang">
                            <span>
                              <span
                                class="flag-icon mr-1"
                                [ngClass]="lang.iconClass"></span>
                              {{ lang.exonym }}
                              <span class="spacer"></span>
                              @if (lang.isVerified) {
                                <mat-icon
                                  class="verified"
                                  [ngStyle]="{
                                    transform: 'scale(0.7)',
                                    verticalAlign: 'middle',
                                  }">
                                  verified
                                </mat-icon>
                              }
                            </span>
                          </mat-option>
                        }
                      }
                    </mat-optgroup>
                    <mat-optgroup label="Unverified">
                      @for (lang of languages; track lang) {
                        @if (!lang.isVerified) {
                          <mat-option [value]="lang">
                            <span
                              class="flag-icon mr-1"
                              [ngClass]="lang.iconClass"></span>
                            {{ lang.exonym }}
                          </mat-option>
                        }
                      }
                    </mat-optgroup>
                  </mat-select>
                </mat-form-field>
              </div>
              <i class="fa fa-arrow-right divider"></i>
              <div class="language-out">
                <mat-form-field appearance="outline">
                  <mat-select
                    panelWidth="null"
                    hideSingleSelectionIndicator
                    #languageOutSelector
                    [disabled]="translationsDisabled()"
                    (valueChange)="languageOutChanged(-1, $event)"
                    [value]="
                      this.languageService.getLangFromCode(
                        (this.kit | async).microphones[0]?.language_out ||
                          (this.localLanguageOut$ | async)
                      )
                    ">
                    <mat-select-trigger>
                      <span
                        class="flag-icon mr-1"
                        [ngClass]="languageOutSelector.value?.iconClass"></span>
                      {{
                        languageOutSelector.value?.languageCode
                          .substring(0, 2)
                          .toUpperCase()
                      }}
                    </mat-select-trigger>
                    <mat-optgroup label="Verified">
                      @for (lang of languages; track lang) {
                        @if (lang.isVerified) {
                          <mat-option [value]="lang">
                            <span>
                              <span
                                class="flag-icon mr-1"
                                [ngClass]="lang.iconClass"></span>
                              {{ lang.exonym }}
                              @if (lang.isVerified) {
                                <mat-icon
                                  class="verified"
                                  [ngStyle]="{
                                    transform: 'scale(0.7)',
                                    verticalAlign: 'middle',
                                  }">
                                  verified
                                </mat-icon>
                              }
                            </span>
                          </mat-option>
                        }
                      }
                    </mat-optgroup>
                    <mat-optgroup label="Unverified">
                      @for (lang of languages; track lang) {
                        @if (!lang.isVerified) {
                          <mat-option [value]="lang">
                            <span
                              class="flag-icon mr-1"
                              [ngClass]="lang.iconClass"></span>
                            {{ lang.exonym }}
                          </mat-option>
                        }
                      }
                    </mat-optgroup>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          }
          @case ('each') {
            @for (mic of (this.kit | async).microphones; track mic.id) {
              <div class="mic-settings__mic">
                <div class="icon">
                  <i class="fa fa-microphone" [style.color]="mic.color_hex"></i>
                  <!-- <div class="icon__mic-name">{{ mic.color_hex }}</div> -->
                </div>
                <div class="language-in">
                  <mat-form-field appearance="outline">
                    <mat-select
                      [disabled]="this.isQRAuthMode"
                      #languageInSelector
                      panelWidth="null"
                      hideSingleSelectionIndicator
                      (valueChange)="languageInChanged(mic.mic_id, $event)"
                      [value]="
                        this.languageService.getLangFromCode(mic.language_in)
                      ">
                      <mat-select-trigger>
                        <span
                          class="flag-icon mr-1"
                          [ngClass]="
                            languageInSelector.value?.iconClass
                          "></span>
                        {{
                          this.languageService.getLanguageCode(
                            languageInSelector.value
                          )
                        }}
                      </mat-select-trigger>
                      <mat-optgroup label="Verified">
                        @for (lang of verifiedLanguages; track lang) {
                          <mat-option [value]="lang">
                            <span>
                              <span
                                class="flag-icon mr-1"
                                [ngClass]="lang.iconClass"></span>
                              {{ lang.exonym }}
                              <mat-icon
                                class="verified"
                                [ngStyle]="{
                                  transform: 'scale(.7)',
                                  verticalAlign: 'middle',
                                }">
                                verified
                              </mat-icon>
                            </span>
                          </mat-option>
                        }
                      </mat-optgroup>
                      <mat-optgroup label="Unverified">
                        @for (lang of unverifiedLanguages; track lang) {
                          <mat-option [value]="lang">
                            <span
                              class="flag-icon mr-1"
                              [ngClass]="lang.iconClass"></span>
                            {{ lang.exonym }}
                          </mat-option>
                        }
                      </mat-optgroup>
                    </mat-select>
                  </mat-form-field>
                </div>
                <i class="fa fa-arrow-right divider"></i>
                <div class="language-out">
                  <mat-form-field appearance="outline">
                    <mat-select
                      #languageOutSelector
                      panelWidth="null"
                      hideSingleSelectionIndicator
                      [disabled]="translationsDisabled()"
                      (valueChange)="languageOutChanged(mic.mic_id, $event)"
                      [value]="
                        this.languageService.getLangFromCode(mic.language_out)
                      ">
                      <mat-select-trigger>
                        <span
                          class="flag-icon mr-1"
                          [ngClass]="
                            languageOutSelector.value?.iconClass
                          "></span>
                        {{
                          this.languageService.getLanguageCode(
                            languageOutSelector.value
                          )
                        }}
                      </mat-select-trigger>
                      <mat-optgroup label="Verified">
                        @for (lang of verifiedLanguages; track lang) {
                          <mat-option [value]="lang">
                            <span>
                              <span
                                class="flag-icon mr-1"
                                [ngClass]="lang.iconClass"></span>
                              {{ lang.exonym }}
                              <mat-icon
                                [ngStyle]="{
                                                                    transform: 'scale(.7)',
                                  verticalAlign: 'middle',
                                }">
                                verified
                              </mat-icon>
                            </span>
                          </mat-option>
                        }
                      </mat-optgroup>
                      <mat-optgroup label="Unverified">
                        @for (lang of unverifiedLanguages; track lang) {
                          <mat-option [value]="lang">
                            <span
                              class="flag-icon mr-1"
                              [ngClass]="lang.iconClass"></span>
                            {{ lang.exonym }}
                          </mat-option>
                        }
                      </mat-optgroup>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            }
          }
        }
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button class="mat-mdc-button" mat-dialog-close>{{ 'language_setting.cancel' | transloco }}</button>
  <button mat-button class="mat-mdc-button" (click)="save()" cdkFocusInitial>
    {{ 'language_setting.save' | transloco }}
  </button>
</mat-dialog-actions>
